import React from 'react'

import * as h from 'h'

export default class Z extends React.Component {
  onClick (e) {
    const { onClick } = this.props

    if (onClick) {
      // Prevent default
      if (e) {
        e.preventDefault()
      }

      // Bubble up
      onClick(...arguments)
    }
  }

  render () {
    return h.a({
      href: '#',
      ...this.props,
      onClick: ::this.onClick
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Z/index.js